<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
  #app{
    background: #fff;
    min-height: 100vh;
    width: 100vw;
    position: relative;
    -webkit-overflow-scrolling: touch;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .flex-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /*取消tabs默认margin底部*/
  .el-tabs__header{
    margin: 0!important;
  }
  /*tabs默认高度太低*/
  .el-tabs__item{
    height: .88rem!important;
    line-height: .88rem!important;
  }
  /*vuePicker组件header位置偏低*/
  .vuePicker .header{
    line-height: 18px!important;
  }
  /*rate评分icon相距太大*/
  .el-rate__icon{
    margin-right: 0!important;
  }
  /*隐藏drawer header*/
  .noHeader .el-drawer__header{
    display: none!important;
  }
  /*设置drawer高度*/
  .btt{
    height: auto !important;
  }
  /*修改头像背景*/
  .el-avatar{
    background-color: #eeeeee!important;
  }
  .el-avatar>img{
    width: 100%;
  }
  .el-message{
    font-size: .32rem!important;
    min-width: 4.2rem!important;
  }
  .el-dialog__body{
    padding: .2rem .4rem .4rem .4rem!important;
    font-size: .24rem!important;
  }
  .el-dialog__title{
    font-size: .3rem!important;
  }
  .el-dialog__header {
    padding: .2rem 0 0 .4rem!important;
  }
  .el-dialog__headerbtn{
    top:.2rem!important;
  }
  /*选人页面radio按钮不需要lable*/
  .select-no-label .el-radio__label{
    display: none!important;
  }
  /*单选按钮被选中时 添加背景色*/
  .el-radio.is-bordered.is-checked {
    border-color: #409EFF!important;
    background-color: #D5E3FE!important;
  }
  .el-message-box{
    width: 90%!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue